import { NgModule } from "@angular/core";
import { AngularSignaturePadModule } from "@almothafar/angular-signature-pad";
import { SharedModule } from "../common/common.module";
import { CertificateComponent } from "./certificate/certificate.component";
import { CodComponent } from "./cod/cod.component";
import { ConfirmDetailsComponent } from "./confirm-details/confirm-details.component";
import { JobCreateConfirmComponent } from "./create-confirm/create-confirm.component";
import { CreateComponent } from "./create/create.component";
import { DetailsComponent } from "./details/details.component";
import { FacebookCreateComponent } from "./facebook-create/facebook-create.component";
import { InvoicePrintComponent } from "./invoice-print/invoice-print.component";
import { InvoiceComponent } from "./invoice/invoice.component";
import { JobMachinePrintComponent } from "./job-machine-print/job-machine-print.component";
import { JobRoutingModule } from "./job-routing.module";
import { LineListComponent } from "./line-list/line-list.component";
import { LineModalComponent } from "./line-modal/line-modal.component";
import { LineComponent } from "./line/line.component";
import { ListLiteComponent } from "./list-lite/list-lite.component";
import { ListComponent } from "./list/list.component";
import { LoanUnitComponent } from "./loan-unit/loan-unit.component";
import { PrintComponent } from "./print/print.component";
import { ReceiptComponent } from "./receipt/receipt.component";
import { ScheduleJobComponent } from "./schedule-job/schedule-job.component";
import { SearchComponent } from "./search/search.component";
import { SummaryComponent } from "./summary/summary.component";
import { ChecklistComponent } from "./checklist/checklist.component";
import { ChecklistCommentComponent } from './checklist-comment/checklist-comment.component';
import { GPSTrackingFieldComponent } from "./details/gps-tracking-field/gps-tracking-field.component";
import { LoanUnitTestBedComponent } from "./loan-unit/state-control-test-bed/loan-unit.component";
import { JobValidationComponent } from "./validation/validation.component";
import { ExchangeListComponent } from "./exchange/exchange-list.component";

@NgModule({
  declarations: [
    SearchComponent,
    DetailsComponent,
    ListComponent,
    SummaryComponent,
    ListLiteComponent,
    CreateComponent,
    JobCreateConfirmComponent,
    JobValidationComponent,
    LineModalComponent,
    ScheduleJobComponent,
    ConfirmDetailsComponent,
    PrintComponent,
    CodComponent,
    FacebookCreateComponent,
    CertificateComponent,
    ReceiptComponent,
    LineListComponent,
    LineComponent,
    LoanUnitComponent,
    LoanUnitTestBedComponent,
    InvoiceComponent,
    InvoicePrintComponent,
    JobMachinePrintComponent,
    ChecklistComponent,
    ChecklistCommentComponent,
    GPSTrackingFieldComponent,
    ExchangeListComponent
  ],
  imports: [
    SharedModule,
    JobRoutingModule,
    AngularSignaturePadModule
  ],
  exports: [
    SearchComponent,
    ChecklistComponent,
    JobCreateConfirmComponent
  ]
})
export class JobModule { }
